global.site_name = "Earwig";
